import getWithXHR from 'Common/utils/getWithXHR'

const url = '/api/v1/flashcards'

/**
 *
 * @param {object} [config={}]
 * @param {number[]} config.exclude - array of flashcard IDs to exclude from the random selection
 * @returns {object[]} flashcards - an array of 40 random flashcards
 */
const getRandomFlashcards = ({ exclude = [] } = {}) =>
  getWithXHR(`${url}?exclude=${exclude.toString()}`)

export default getRandomFlashcards
